import React, { useState } from "react";
import Sidebar from "./sidebar/Sidebar.js";
import { Outlet } from "react-router";
import Breadcrumb from "./breadcomeTitle/Breadcrumb.js";

const Layout = (props) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="layout">
      <div className="layout-inner flex">
        <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
        <div className="pagescreen w-full h-screen overflow-y-auto py-[20px] pr-[20px] ">
          <Breadcrumb componentRoutes={props.componentRoutes} />
          <Outlet />
        </div>
        {/* <motion.div
          className="framer-motion"
          initial={{ width: 270 }}
          animate={{ width: isCollapsed ? 50 : 270 }}
          onMouseEnter={() => setIsCollapsed(false)}
          onMouseLeave={() => setIsCollapsed(true)}
        >
          <div className="bg-red-600 h-screen">
            {isCollapsed && (

              <div className="inner flex gap-4">
                <p>dfs</p>
                <p>dfsdsfsdfsfffgfgfsdgsdfgfsdgdg</p>
              </div>
            )}
          </div>
          <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
        </motion.div>
        <motion.div
          animate={{ width: isCollapsed ? "100% ml-[20px]" : "calc(100% - 270px) ml-[50px]" }}
          onMouseEnter={() => setIsCollapsed(true)}
        // onMouseLeave={() => setIsCollapsed(false)}
        >
          <div className="pagescreen w-full py-[20px] pr-[20px] ">
            <Breadcrumb componentRoutes={props.componentRoutes} />
            <Outlet />
          </div>
        </motion.div> */}
      </div>
    </div>
  );
};

export default Layout;
